import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';

import {
  addCustomDomain,
} from 'redux/settings/actions';

import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonPopup from 'components/common/CommonPopup';

import { cutHTTP } from 'utils/fixURL';
import validate from './validate';

import './AddDomainForm.css';

const AddDomainForm = ({
  postCustomDomainSuccess,
  postCustomDomainError,
  addCustomDomain,
  valid,
  domainErrors,
  domainToched,
  reset,
  handleSubmit,
  me,
  domain,
}) => {

  if (!me || (me && me.custom_domain)) {
    return null;
  }
  const _handleSubmit = values => {
    const urlValue = cutHTTP(values.url);
    addCustomDomain(urlValue);
    reset();
  };

  return (
    <Translation>
      {(t) => (
        <div className="add-custom-domain-form__component">
          <div className="add-custom-domain-form-wrapper">
            <Form
              onSubmit={handleSubmit(_handleSubmit)}
              error={!valid}
              className={`add-custom-domain-form ${((postCustomDomainError || (me && !me.custom_domain)) && 'full-width') || ''}`}
            >
              {/* Label */}
              <div className="field-label">
                <span>{t("Enter the domain you want to connect to your HeyLink.me page")}</span>
              </div>

              {/* Url */}
              <div className="field-wrapper">
                <div className="field-wrapper-content">
                  <Field
                    component={TextField}
                    name="url"
                    type="text"
                    placeholder={t("e.g. links.example.com")}
                    disabled={postCustomDomainSuccess || (me && me.custom_domain && me.custom_domain.domain)}
                    required
                  />
                  {(
                    (postCustomDomainSuccess && !postCustomDomainError) ||
                    (me && me.custom_domain && me.custom_domain.domain)) &&
                    <CommonPopup
                      successIcon
                      type="success"
                      triggerClassName="field-wrapper-icon"
                    >
                      {me && me.custom_domain && !me.custom_domain.is_verified ? t("Valid domain name") : t("Domain is verified & connected")}
                    </CommonPopup>
                  }
                  {postCustomDomainError &&
                    <CommonPopup
                      errorIcon
                      type="error"
                      triggerClassName="field-wrapper-icon"
                    >
                      {t("Please enter a valid domain name. E.g.: example.com or links.example.com")}
                    </CommonPopup>
                  }
                  {!valid && domainErrors && domainToched &&
                    <CommonPopup
                      errorIcon
                      type="error"
                      triggerClassName="field-wrapper-icon"
                    >
                      {domainErrors}
                    </CommonPopup>
                  }
                </div>
                {(postCustomDomainError ||
                  (me && !me.custom_domain)) &&
                  <Button
                    submit
                    disabled={!valid || !domain}
                  >
                    {t("Next")}
                  </Button>
                }
              </div>
            </Form>
          </div>
        </div>
      )}
    </Translation>
  );
};

AddDomainForm.propTypes = {
  postCustomDomainSuccess: PropTypes.object,
  postCustomDomainError: PropTypes.object,
  addCustomDomain: PropTypes.func,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  me: PropTypes.object,
  valid: PropTypes.bool,
  domainErrors: PropTypes.string,
  domainToched: PropTypes.bool,
  domain: PropTypes.string,
};
AddDomainForm.defaultProps = {
  postCustomDomainSuccess: null,
  postCustomDomainError: null,
  addCustomDomain: null,
  handleSubmit: null,
  reset: null,
  me: null,
  valid: false,
  domainErrors: '',
  domainToched: false,
  domain: null,
};

const setInitialValues = params => {
  const domain = (params.custom_domain && params.custom_domain.domain) || null;
  return {
    url: domain,
  };
};

const mapStateToProps = state => {
  const selector = formValueSelector('AddCustomDomainForm');
  return {
    domain: selector(state, 'url'),
    domainErrors: state.form.AddCustomDomainForm && state.form.AddCustomDomainForm.syncErrors && state.form.AddCustomDomainForm.syncErrors.url,
    domainToched: state.form.AddCustomDomainForm && state.form.AddCustomDomainForm.anyTouched,
    postCustomDomainSuccess: state.settingsReducer.postCustomDomainSuccess,
    postCustomDomainError: state.settingsReducer.postCustomDomainError,
    me: state.usersReducer.me,
    initialValues: setInitialValues(state.usersReducer.me),
  };
};

export default connect(
  mapStateToProps,
  {
    addCustomDomain,
  },
)(reduxForm({
  form: 'AddCustomDomainForm',
  enableReinitialize: true,
  validate,
})(AddDomainForm));
